import { Navigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";
import { openChatSession } from "./chat-instance";
import { resolveCanonicalEntryPoint } from "./live-chat-entry-point";

// Handles `/live-chat?entryPoint=...` deeplinks. Human entries route
// through pre-chat so `POST /v1/live-chat` supplies the authoritative
// `LIVE_CHAT_AVAILABLE` gate + routing attributes on `USER_START_CHAT`.
// AI (and unknown) paths open the shared Eva session directly — Eva
// has no equivalent HOO gate.
//
// In-app Masonry taps on AI `/live-chat` deeplinks never reach this
// route (see `masonry/normalize-deeplink-urls.ts`), so the /home
// redirect only applies to cold entries (typed URL, external link).
export const LiveChatEntryRoute = () => {
  const [params] = useSearchParams();
  const entryPoint = params.get("entryPoint");
  const canonical = resolveCanonicalEntryPoint(entryPoint);

  useEffect(() => {
    // Human path redirects to pre-chat (see Navigate below); nothing
    // to dispatch. AI / unknown open the shared Eva session directly.
    if (canonical === "human") return;
    openChatSession();
  }, [canonical]);

  if (canonical === "human") {
    return <Navigate to={APP_MANAGED_ROUTES.LIVE_CHAT_PRE_CHAT} replace />;
  }
  return <Navigate to={APP_MANAGED_ROUTES.HOME} replace />;
};
